export class CountdownTimer {
    private container: HTMLDivElement;
    private clock: HTMLElement;
    private daysEl: HTMLElement;
    private hoursEl: HTMLElement;
    private minutesEl: HTMLElement;
    private secondsEl: HTMLElement;
    private labelEl: HTMLElement;
    private targetContainerId: string;
    private deadline: Date;
    private intervalId?: number;

    constructor(container: HTMLDivElement) {
        this.container = container;

        this.clock = container.querySelector('.gw-timer__clock') as HTMLElement;
        this.daysEl = this.clock.querySelector(
            '.gw-timer__days'
        ) as HTMLElement;
        this.hoursEl = this.clock.querySelector(
            '.gw-timer__hours'
        ) as HTMLElement;
        this.minutesEl = this.clock.querySelector(
            '.gw-timer__minutes'
        ) as HTMLElement;
        this.secondsEl = this.clock.querySelector(
            '.gw-timer__seconds'
        ) as HTMLElement;
        this.labelEl = this.clock.querySelector(
            '.gw-timer__label'
        ) as HTMLElement;

        const deadlineInput = container.querySelector(
            '.gw-timer__deadline'
        ) as HTMLInputElement;

        if (!deadlineInput || !deadlineInput.value) {
            throw new Error('Missing or invalid .gw-timer__deadline input.');
        }

        this.deadline = new Date(deadlineInput.value);
        this.targetContainerId = 'gw-timer-replace';

        this.startCountdown();
    }

    /**
     * Initializes all countdown timers on the page.
     * This method should be called once the DOM is fully loaded.
     */
    public static start(): void {
        const containers =
            document.querySelectorAll<HTMLDivElement>('[data-gw-timer]');
        containers.forEach((container) => new CountdownTimer(container));
    }

    private startCountdown(): void {
        this.updateClock();
        this.intervalId = window.setInterval(() => this.updateClock(), 1000);
    }

    private updateClock(): void {
        const time = this.getTimeRemaining();

        this.daysEl.textContent = time.days.toString();
        this.hoursEl.textContent = time.hours.toString().padStart(2, '0');
        this.minutesEl.textContent = time.minutes.toString().padStart(2, '0');
        this.secondsEl.textContent = time.seconds.toString().padStart(2, '0');

        if (time.total <= 0) {
            clearInterval(this.intervalId);

            this.container.style.display = 'none';
            const target = document.getElementById(this.targetContainerId);
            if (target) {
                target.style.display = 'block';
            }
        }
    }

    private getTimeRemaining(): {
        total: number;
        days: number;
        hours: number;
        minutes: number;
        seconds: number;
    } {
        const total = this.deadline.getTime() - Date.now();
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
        const days = Math.floor(total / (1000 * 60 * 60 * 24));

        return { total, days, hours, minutes, seconds };
    }
}
